import NchLogoStackedBase from "./FieldTypeBase/NchLogoStackedBase";

const NchLogoStackedInLine = (props) => {
    return(

         <span
            className={`nchLogoStackedInline ${props.field.class || ""}`}
            key={props.objectkey} 
            id={props.objectkey}>
              
                <NchLogoStackedBase {...props} />             

          </span>
    );
}
export default NchLogoStackedInLine;